import type {AgentMetadata} from "~/pages/chat-agent/types/chatTypes";

/** Display names for agent tools whose identifiers read poorly as-is. */
const TOOL_LABELS: Record<string, string> = {
    execute_sql: "Data retrieval",
    create_report: "Report generation",
    export_data: "Data export",
    internet_search: "Internet search",
    consolidate_suppliers: "Supplier consolidation",
    consolidate_all_tail_suppliers: "Tail spend consolidation",
    list_levers: "Lever lookup",
    list_initiatives: "Initiative analysis",
    propose_initiative: "Initiative draft",
    create_initiative: "Initiative creation",
};

/** `load_skill` / `loadSkill` → "Load skill". */
function humanize(name: string): string {
    const words = name
        .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
        .replace(/[_\-.]+/g, " ")
        .trim()
        .toLowerCase();
    return words ? words.charAt(0).toUpperCase() + words.slice(1) : name;
}

/** Readable label for a tool name: a known label, else the humanized name. */
export function toolLabel(toolName: string): string {
    return TOOL_LABELS[toolName] ?? humanize(toolName);
}

/** Readable name for an ADK agent: its `display_name` from agents-metadata, else the humanized name (sub-agents). */
export function agentLabel(agentName: string, agents: AgentMetadata[] | undefined): string {
    return agents?.find(a => a.app_name === agentName)?.display_name ?? humanize(agentName);
}
